import { render, staticRenderFns } from "./user-menu-desktop.vue?vue&type=template&id=ad9fd02e&scoped=true"
import script from "./user-menu-desktop.vue?vue&type=script&lang=ts"
export * from "./user-menu-desktop.vue?vue&type=script&lang=ts"
import style0 from "./user-menu-desktop.vue?vue&type=style&index=0&id=ad9fd02e&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9fd02e",
  null
  
)

export default component.exports